/*=========================================================================================
  File Name: moduleCalendarState.js
  Description: Calendar Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  teachers: [],
  students: [],
  teachersCount: 0,
  studentsCount: 0,
  studentsRegistationX: [],
  studentsRegistationY: [],
}
